import React from 'react'
import Brand_slider from './Brand_slider'
import Mobile_view_brand from './Mobile_view_brand'

function Main_Brand_slider() {
  return (
    <>
      <style>{`
        .Brand_slider_text h2{
        color: #2b1c50;
        font-family: 'Poppins', sans-serif;
        font-size:1.7rem;
        user-select: none;
        } 
      `}</style>
      <div>
        <div className="">
          <div className="container">
            <div className="Brand_slider_text">
              <h2 className="px-2">Our Alumni Works At</h2>
            </div>
            <div className="conatiner-fluid mt-4">
              <div className="container">
                <div className="d-none d-md-block">
                  <Brand_slider />
                </div>
                <div className="d-sm-block d-md-none">
                  <Mobile_view_brand />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Main_Brand_slider
